/**
 * group-testing — arranges the TESTING segment hierarchically (pure): each
 * live path becomes a section with its landers/offers nested under it (matched
 * by the item's pathId). Items whose path isn't in the testing list (edge:
 * data drift) fall into a trailing headerless group so nothing is hidden.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { QueueElement } from '@trafficpulse/shared';

export interface TestingGroup {
  /** The live path heading the section; undefined = orphan items group. */
  path?: QueueElement;
  items: QueueElement[];
}

export function groupTesting(elements: QueueElement[]): TestingGroup[] {
  const paths = elements.filter((el) => el.layer === 'paths');
  const items = elements.filter((el) => el.layer !== 'paths');
  const groups = paths.map<TestingGroup>((path) => ({
    path,
    items: items.filter((item) => item.pathId === path.itemId),
  }));
  const claimed = new Set(groups.flatMap((g) => g.items));
  const orphans = items.filter((item) => !claimed.has(item));
  if (orphans.length > 0) groups.push({ items: orphans });
  return groups;
}
